import { render, staticRenderFns } from "./resignationInheritance.vue?vue&type=template&id=01eb8e24&scoped=true"
import script from "./resignationInheritance.vue?vue&type=script&lang=js"
export * from "./resignationInheritance.vue?vue&type=script&lang=js"
import style0 from "./resignationInheritance.vue?vue&type=style&index=0&id=01eb8e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb8e24",
  null
  
)

export default component.exports